import { isCOIPath } from '~/utils';

const RELOAD_KEY = 'nuxt_sw_reloading';

const performReload = () => {
  sessionStorage.setItem(RELOAD_KEY, 'true');
  window.location.reload();
};

const setupServiceWorker = async (type) => {
  if (!('serviceWorker' in navigator)) return;

  const swName =
    type === 'global' ? '/global-service-worker.js' : '/call-service-worker.js';
  const scope = type === 'global' ? '/' : '/call';

  const registrations = await navigator.serviceWorker.getRegistrations();

  const activeReg = registrations.find(
    (reg) => reg.active?.scriptURL.includes(swName) && reg.scope.endsWith(scope)
  );

  if (!activeReg) {
    for (const reg of registrations) {
      await reg.unregister();
    }

    await navigator.serviceWorker.register(swName, { scope });
    performReload();
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();

  nuxtApp.hook('app:mounted', async () => {
    // Se siamo appena dopo un reload indotto dal plugin, fermiamoci qui
    if (sessionStorage.getItem(RELOAD_KEY) === 'true') {
      sessionStorage.removeItem(RELOAD_KEY);
      return;
    }

    const currentMode = isCOIPath(router.currentRoute.value)
      ? 'call'
      : 'global';
    await setupServiceWorker(currentMode);
  });

  router.afterEach(async (to, from) => {
    const toCOI = isCOIPath(to);
    const fromCOI = isCOIPath(from);

    if (toCOI !== fromCOI) {
      await setupServiceWorker(toCOI ? 'call' : 'global');
    }
  });
});
